export default {
  deleteButtonText: 'Delete',
  modalDeleteText: 'Are you sure you want to delete the message?',
  modalMultipleDeleteText: 'Do you want to permanently delete the selected messages?',
  modalDeleteConfirmButtonText: 'Delete',
};
